<template>
	<!--
DOC
esempio di custom element vue
-->

	<div style="display: flex; width: auto">
		<div>
			<md-avatar class="md-avatar-icon md-primary">
				<i class="el-icon-user pointer" style="color: white"></i>
			</md-avatar>
		</div>
		<div style="margin-left: 10px; margin-top: auto; margin-bottom: auto">
			<div style="font-size: 18px; width: auto">{{ item.contact.name }}</div>
			<div>{{ item.contact.email }}</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
	name: "Employee",
	props: ["item"],
	computed: {
		...mapGetters({
			list: "builder/list"
		})
	},
	mounted() {}
}
</script>
<style scoped></style>
